import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { RouterProvider} from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import {router} from "./App";
import { ToastContainer } from "react-toastify";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
     <ToastContainer position="top-right" />
  <RouterProvider router={router} />
  </Provider>
);
